import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from '@/lang/zh.js'
import store from '@/store/index'

Vue.use(VueI18n)

/**
 * 20 个语种与后端 dp_lang(status=1) 对齐。
 *
 * 词表全部内置会让首屏 JS 变成 9MB 左右（19 份各 350KB 上下），落地页扛不住。
 * 所以除中文以外都拆成独立 chunk：切到哪个语种，才去下载那一份。
 * zh-CN 直接内置并作为 fallbackLocale —— 词条 key 就是中文原文，
 * 任何语种缺词时 vue-i18n 显示 key 本身，天然退回中文而不是显示英文。
 */
const LOADERS = {
  'zh-TW': () => import('@/lang/zh-TW.js'),
  'en': () => import('@/lang/en.js'),
  'ja': () => import('@/lang/ja.js'),
  'ko': () => import('@/lang/ko.js'),
  'ru': () => import('@/lang/ru.js'),
  'de': () => import('@/lang/de.js'),
  'fr': () => import('@/lang/fr.js'),
  'es': () => import('@/lang/es.js'),
  'pt': () => import('@/lang/pt.js'),
  'it': () => import('@/lang/it.js'),
  'ar': () => import('@/lang/ar.js'),
  'tr': () => import('@/lang/tr.js'),
  'vi': () => import('@/lang/vi.js'),
  'th': () => import('@/lang/th.js'),
  'id': () => import('@/lang/id.js'),
  'ms': () => import('@/lang/ms.js'),
  'kk': () => import('@/lang/kk.js'),
  'my': () => import('@/lang/my.js'),
  'lo': () => import('@/lang/lo.js'),
}

const i18n = new VueI18n({
  locale: store.state.langdef,
  fallbackLocale: 'zh-CN',
  messages: { 'zh-CN': zh },
  silentTranslationWarn: true, // 缺词警告太吵，缺词会自动回退中文
})

// 正在下载中的语言，避免连点下拉重复请求
const pending = {}

/**
 * 确保某个语种的词表已经装进 i18n。
 * 首屏和切换语言都要先等它 resolve，否则会先闪一下中文（key 原文）。
 */
export function loadLocale (sign) {
  if (!sign || sign === 'zh-CN') return Promise.resolve()
  if (Object.keys(i18n.getLocaleMessage(sign) || {}).length) return Promise.resolve()
  if (pending[sign]) return pending[sign]
  const loader = LOADERS[sign]
  if (!loader) return Promise.resolve()
  pending[sign] = loader()
    .then((m) => {
      i18n.setLocaleMessage(sign, m.default || m)
      delete pending[sign]
    })
    .catch((e) => {
      // 词表没下载成功就留在中文，不要让整个页面挂掉
      delete pending[sign]
      if (process.env.NODE_ENV !== 'production') console.error('[i18n] 词表加载失败', sign, e)
    })
  return pending[sign]
}

export default {
  getI18n () {
    return i18n
  },
  loadLocale,
}
